module.exports = __webpack_public_path__ + "static/media/Screenshot_3-thumb.2ad80f14.png";